import React from 'react';
import InfoGrid from "../../../../../../../components/info-grid/info-grid.jsx";
import ReportUtils from "../../../../../../../utils/report-utils.js";

const IndividualAddresses = ({item}) => {
    const addresses = item.addresses ?? []
    const homeless = item?.homelessSituation ? "SIM" : "Não";

    return (
        <>
            { addresses && (
                <section className="space-y-4!">
                    <div className={`text-[16px] font-semibold text-[#4F4F4F] mb-2 print:break-after-avoid!`}>
                        Endereços
                    </div>

                    <div className="pb-0.5!">
                        <span className={'text-[13px] text-[#4F4F4F] print:text-[15px]! font-normal pr-1'}>Situação de rua:</span>
                        <span className={'text-[14px] print:text-[17px] font-normal'}>{homeless}</span>
                    </div>

                    { addresses.map((item, index) => {

                        const info = [
                            {
                                label: "Logradouro",
                                value: item?.address ?? "",
                            },
                            {
                                label: "Número",
                                value: item?.number ?? "",
                            },
                            {
                                label: "Bairro",
                                value: item?.neighborhood ?? "",
                            },
                            {
                                label: "Complemento",
                                value: item?.complement ?? "",
                            },
                            {
                                label: "Município",
                                value: item?.city ?? "",
                            },
                            {
                                label: "CEP",
                                value: item?.zipCode ?? "",
                            },
                            {
                                label: "Tipo",
                                value: item?.type ?? "",
                            },
                            {
                                label: "Data",
                                value: ReportUtils.formatDateOnly(item?.date) ?? "",
                            }
                        ];

                        return (
                            <>
                                <InfoGrid key={`${index}`} title={""} items={info} columns={3} labelClassName="text-[#4F4F4F] text-[13px]! print:text-[15px]!" valueClassName={'print:text-[17px]!'} className={'pb-3 px-0!'} contentClassName={'space-y-1'}/>
                            </>
                        )

                    })}
                </section>
            )}
        </>
    );
};

export default IndividualAddresses;